/** Mock: senha incorreta dispara erro no campo (Figma 8418-8247). */
export const MOCK_CERTIFICATE_INVALID_PASSWORD = "senha-incorreta";

export const MOCK_COMPANY_PROFILE = {
	companyName: "Carros SA",
	cnpj: "12.345.678/0001-90",
} as const;

export const CERTIFICATE_ACCEPT = ".pfx,.p12,application/x-pkcs12";

export const CERTIFICATE_MAX_SIZE_BYTES = 10 * 1024 * 1024;
